
import { mixins, Options } from "vue-class-component";
import GuestLayout from "@/layout/GuestLayout.vue";
import Validation from "@/components/validation/Validation.vue";
import { required } from "@vuelidate/validators";
import { namespace } from "vuex-class";
import { GuestFormMixin } from "@/mixins/form/GuestFormMixin";

const AuthModule = namespace("auth");

@Options({
  components: { Validation, GuestLayout },
  emits: ["close"],
  validations: {
    username: { required },
    password: { required },
  },
})
export default class Login extends mixins(GuestFormMixin) {
  private username?: string | null = null;
  private password?: string | null = null;
  private rememberMe = false;

  @AuthModule.Action("signIn")
  private signInAction: any;

  @AuthModule.Getter("getIsLoading")
  private isLoading: any;

  @AuthModule.Getter("getError")
  private error: any;

  private onSubmit(): void {
    if (this.isInvalidate()) {
      return;
    }
    localStorage.setItem("rememberMe", this.rememberMe.toString());
    this.signInAction({
      username: this.username,
      password: this.password,
      remember_me: this.rememberMe,
    });
  }

  private goToResetPass() {
    this.$router.push({ name: "ResetPasswordRequest" });
  }

  public mounted(): void {
    this.rememberMe = localStorage.getItem("rememberMe") === "true";
  }
}
